import {trigger, state, animate, style, transition} from '@angular/animations';

export const  slideToLeftAnimation =
   trigger('slideToLeftAnimation', [
    state('void', style({position: 'fixed', width: '100%'}) ),
    state('*', style({position: 'fixed', width: '100%'}) ),
    transition(':enter', [
      style({transform: 'translateX(100%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateX(0%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(-100%)'}))
    ])
  ]);

export const slideToTopAnimation =
  trigger('slideToTopAnimation', [
    state('void', style({position: 'absolute', width: '100%'}) ),
    transition(':enter', [  // before 2.1: transition('void => *', [
      style({transform: 'translateY(20%)', opacity: 0}),
      animate('0.35s ease-out', style({transform: 'translateY(0%)', opacity: 1}))
    ]),
    transition(':leave', [  // before 2.1: transition('* => void', [
      style({transform: 'translateY(0%)', opacity: 1}),
      animate('0.3s ease-out', style({transform: 'translateY(-20%)', opacity: 0}))
    ])
  ]);
  export const slideLeftAnimation =
  trigger('slideLeftAnimation', [
    // state('void', style({position:'fixed', width:'100%'}) ),
    transition(':enter', [  // before 2.1: transition('void => *', [
      style({transform: 'translateX(-100%)'}),
      animate('0.08s ease-out', style({transform: 'translateX(0%)'}))
    ]),
    transition(':leave', [  // before 2.1: transition('* => void', [
      style({transform: 'translateX(0%)'}),
      animate('0.05s ease-out', style({transform: 'translateX(-100%)'}))
    ])
  ]);

  export const slideRightAnimation =
  trigger('slideRightAnimation', [
    // state('void', style({position:'fixed', width:'100%'}) ),
    transition(':enter', [  // before 2.1: transition('void => *', [
      style({transform: 'translateX(100%)'}),
      animate('0.08s ease-out', style({transform: 'translateX(0%)'}))
    ]),
    transition(':leave', [  // before 2.1: transition('* => void', [
      style({transform: 'translateX(0%)'}),
      animate('0.05s ease-out', style({transform: 'translateX(100%)'}))
    ])
  ]);


  export const fadeFromRight =
  trigger('fadeFromRight', [

    transition(':enter', [  // before 2.1: transition('void => *', [
      style({transform: 'translateX(50%)', opacity: 0}),
      animate('0.2s ease-out', style({transform: 'translateX(0%)', opacity: 1}))
    ]),
    // transition(':leave', [  // before 2.1: transition('* => void', [
    //   style({transform: 'translateX(0%)', opacity: 1}),
    //   animate('0.2s ease-in', style({transform: 'translateX(100%)', opacity: 0, width: '0px'}))

    // ])
  ]);

  export const fadeFromLeft =
  trigger('fadeFromLeft', [

    transition(':enter', [  // before 2.1: transition('void => *', [
      style({transform: 'translateX(-100%)', opacity: 0}),
      animate('0.2s ease-out', style({transform: 'translateX(0%)', opacity: 1}))
    ]),
    transition(':leave', [  // before 2.1: transition('* => void', [
      style({transform: 'translateX(0%)', opacity: 1}),
      animate('0.2s ease-in', style({transform: 'translateX(-100%)', opacity: 0}))
    ])
  ]);


